"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var context_1 = require("../../../context");
var enums_1 = require("../../../types/enums");
var FormControl_1 = __importDefault(require("../../FormControl"));
var RadioInput_1 = __importDefault(require("../../RadioInput"));
var ReferralsRequireApprovalInput = function () {
    var trans = context_1.useSemantics().trans;
    var errors = formik_1.useFormikContext().errors;
    return (react_1.default.createElement(FormControl_1.default, { errors: errors.block_referrals, dusk: "block-referrals-field", label: trans('optiiva::labels.block-referrals'), flush: true },
        react_1.default.createElement(RadioInput_1.default, { name: "block_referrals", label: trans('optiiva::labels.yes'), value: enums_1.BooleanOption.YES }),
        react_1.default.createElement(RadioInput_1.default, { name: "block_referrals", label: trans('optiiva::labels.no'), value: enums_1.BooleanOption.NO })));
};
exports.default = ReferralsRequireApprovalInput;
//# sourceMappingURL=ReferralsRequireApprovalInput.js.map